import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getShiftAssigendJobs } from "../../slice/workerShiftAddJobSlice";
import { useNavigate } from "react-router-dom";

const EmployerAssigendJobs = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const token = localStorage.getItem("token");
    const { shiftAssignedJobs, loading, error } = useSelector(
        (state) => state.workerShiftJob
    );

    useEffect(() => {
        if (!token) return;

        dispatch(getShiftAssigendJobs(token));
    }, [token, dispatch]);

    console.log("shiftAssignedJobs", shiftAssignedJobs);

    return (
        <>
            <div className="col-md-8 col-xl-9 mt-4 mt-md-0">
                <div className="ps-2 ps-lg-4">
                    <h4 className="font-weight-bold text-primary font-size-40 mb-4 pb-1 line-hight-2 border-bottom pb-3 montserrat">
                        Assigned Shift Request
                    </h4>
                    {/* 🔄 Loading */}
                    {loading && (
                        <div className="d-flex justify-content-center py-5">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    )}

                    {/* ❌ Error */}
                    {!loading && error && (
                        <div className="alert alert-danger text-center">
                            {error}
                        </div>
                    )}

                    {/* ✅ Shift Cards */}
                    {!loading && !error && (
                        shiftAssignedJobs.length > 0 ? (
                            shiftAssignedJobs.map((offer) => (
                                <div className="card shadow-sm mb-4 border-0 rounded-3" key={offer.id}>
                                    <div className="card-body p-4">
                                        {/* Title */}
                                        <h5 className="text-primary fw-bold mb-3" style={{ fontSize: "1.25rem" }}>
                                            {offer.title || "Shift Job Request"}
                                        </h5>

                                        {/* Worker info */}
                                        {offer.worker_name && (
                                            <p className="mb-3">
                                                <strong className="me-2">👤 Worker</strong>
                                                <span className="text-dark">{offer.worker_name} {offer.worker_email && `| ${offer.worker_email}`} {offer.worker_phone && `| ${offer.worker_phone}`}</span>
                                            </p>
                                        )}

                                        {/* Location */}
                                        <p className="mb-3">
                                            <strong className="me-2">📍 Location:</strong>
                                            <span className="text-dark">{offer.city}, {offer.state}, {offer.country}</span>
                                        </p>

                                        {/* Salary Type / Ratio */}
                                        <p className="mb-3">
                                            <strong className="me-2">⚖️ Salary Type:</strong>
                                            <span className="badge bg-info text-dark">{offer.ratio || "Hourly"}</span>
                                        </p>

                                        {/* Dates */}
                                        <p className="mb-3">
                                            <strong className="me-2">📅 Date:</strong>
                                            <span className="text-dark">
                                                {offer.start_date}{offer.end_date && ` - ${offer.end_date}`}
                                            </span>
                                        </p>

                                        {/* Timings */}
                                        <p className="mb-3">
                                            <strong className="me-2">🕒 Working Timings:</strong>
                                            <span className="text-dark">
                                                {offer.start_time}{offer.end_time && ` - ${offer.end_time}`}
                                            </span>
                                        </p>



                                        <div className="d-flex gap-3 mt-3">
                                            <button
                                                className="btn btn-light-header"
                                                onClick={(e) => {
                                                    navigate(`/panel/assigned-shift-job-details/${offer.id}`)
                                                }}
                                            >
                                                Details
                                            </button>
                                        </div>


                                    </div>
                                </div>
                            ))
                        ) : (
                            <p className="text-muted text-center">
                                No shift job offers found.
                            </p>
                        )
                    )}
                </div>
            </div>
        </>
    )
}
export default EmployerAssigendJobs;